import script from "./PlatformGoodsItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformGoodsItem.vue?vue&type=script&lang=ts&setup=true"

import "./PlatformGoodsItem.vue?vue&type=style&index=0&id=627591a8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-627591a8"]])

export default __exports__